<template>
    <div class="calender windows">
        <label>
            <input hidden type="checkbox" v-model="togglerDate" id="cbxToggler">
            <span>ميلادي</span>
            <span>هجري</span>
            <span class="active"></span>
        </label>

        <!-- =========================== -->
        <!-- cooment until next ramadan -->
        <!-- =========================== -->

        <!-- <button class="ramadanBtn">
            <span><i class="fas fa-star-and-crescent"></i></span>
            <span>رمضان</span>
        </button>
        <div class="ramadanDate">
            <h2 class="currrentDay">current day</h2>
            <br>

            <div>
                !-- HLR --
                <section>
                    <p>منتصف رمضان</p>
                    <p class="halfLeft">NaN</p>
                </section>
                !-- LDR --
                <section>
                    <p>الأيام المتبقية من رمضان</p>
                    <p class="daysLeft">NaN</p>
                </section>
                !-- ELD --
                <section>
                    <p>الأيام المتبقية على عيد الفطر</p>
                    <p class="iftarDay">NaN</p>
                </section>
            </div>

        </div> -->

        <br><br>

        <transition appear key="h" type="transition" mode="out-in" name="sliderr">
            <hijry-section v-if="togglerDate"></hijry-section>
        </transition>
        <transition appear key="m" type="transition" mode="out-in" name="sliderr">
            <milady-section v-if="!togglerDate"></milady-section>
        </transition>
        
        
    </div>
</template>


<script>
import hijryS from "./calender-cmp/hijry-cmp.vue"
import miladyS from "./calender-cmp/milady-cmp.vue"
export default {
    data() {
        return {
            togglerDate: false,
        }
    },
    components: {
        hijrySection: hijryS,
        miladySection: miladyS
    }
}
</script>



<style scoped>
.sliderr-enter {
    transform: translateY(0);
    opacity: 1;
    transition: 0.4s ease all !important;
}
.sliderr-enter-active {
    transform: translateY(-15px);
    opacity: 0;
    transition: 0.4s ease all !important;
}
.sliderr-leave {
    transform: translateY(0);
    opacity: 1;
    transition: 0.4s ease all !important;
}
.sliderr-leave-active {
    opacity: 0;
    transform: translateY(-15px);
    transition: 0.4s ease all !important;
}
</style>